export const ImagesAssets = {
    CardImages: require('../../../src/assets/images/profile_user.png'), 
    USER: require('../../../src/assets/images/image.png'), 


}